import { render, staticRenderFns } from "./Sunrise.vue?vue&type=template&id=329724c5&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329724c5",
  null
  
)

export default component.exports